
import { NotesKeys } from '@/i18n/types/notes.types';

export const notes: Record<NotesKeys, string> = {
  notes: 'Notes',
  notesDescription: 'Create and manage personal notes and documents.',
  newNote: 'New Note',
  yourNotes: 'Your Notes',
  createNote: 'Create Note',
  editNote: 'Edit Note',
  selectOrCreateNote: 'Select or Create a Note',
  noteTitle: 'Note Title',
  noteContent: 'Note Content',
  saving: 'Saving',
  saveNote: 'Save Note',
  titleRequired: 'Title is required',
  noteCreated: 'Note Created',
  noteUpdated: 'Note Updated',
  noteDeleted: 'Note Deleted',
  noteCreatedSuccess: 'Your note has been created successfully',
  noteUpdatedSuccess: 'Your note has been updated successfully',
  noteDeletedSuccess: 'Your note has been deleted successfully',
  deleteNote: 'Delete Note',
  deleteNoteConfirmation: 'Are you sure you want to delete this note? This action cannot be undone.',
  selectNoteOrCreateNew: 'Select a note from the list or create a new one',
  noNotesYet: 'No notes yet. Click the "New Note" button to create one.',
  loading: 'Loading...',
  error: 'Error',
  errorFetchingNotes: 'Error loading notes. Please try again.',
  errorCreatingNote: 'Error creating note. Please try again.',
  errorUpdatingNote: 'Error updating note. Please try again.',
  errorDeletingNote: 'Error deleting note. Please try again.',
  errorSavingNote: 'Error saving note. Please try again.',
  mustBeLoggedIn: 'You must be logged in to perform this action.',
  // Nuevas traducciones - Fase 1
  favorites: 'Favorites',
  trash: 'Trash',
  folders: 'Folders',
  addToFavorites: 'Add to Favorites',
  removeFromFavorites: 'Remove from Favorites',
  moveToTrash: 'Move to Trash',
  restoreFromTrash: 'Restore from Trash',
  deletePermanently: 'Delete Permanently',
  emptyTrash: 'Empty Trash',
  createFolder: 'Create Folder',
  folderName: 'Folder Name',
  moveToFolder: 'Move to Folder',
  audioNote: 'Audio Note',
  videoNote: 'Video Note',
  recordAudio: 'Record Audio',
  recordVideo: 'Record Video',
  stopRecording: 'Stop Recording',
  playRecording: 'Play Recording',
  wordCount: 'Word Count',
  charactersRemaining: 'characters remaining',
  titleTooLong: 'Title is too long',
  unsavedChanges: 'Unsaved changes',
  autoSaving: 'Auto saving...',
  addTag: 'Add tag',
  selectNoteHint: 'Select a note from the list to edit it.',
  searchInContent: 'Search in content',
  sortBy: 'Sort by',
  sortByTitle: 'Title',
  sortByDate: 'Date',
  sortByContent: 'Content',
  ascending: 'Ascending',
  descending: 'Descending',
  allNotes: 'All Notes',
  notesInTrash: 'Notes in Trash',
  favoriteNotes: 'Favorite Notes',
  // Fase 2 - Editor y Organización
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  bulletList: 'Bullet List',
  numberedList: 'Numbered List',
  quote: 'Quote',
  code: 'Code',
  formatText: 'Format Text',
  noteTemplates: 'Note Templates',
  selectTemplate: 'Select Template',
  blankNote: 'Blank Note',
  meetingNotes: 'Meeting Notes',
  dailyJournal: 'Daily Journal',
  projectPlan: 'Project Plan',
  taskList: 'Task List',
  subfolders: 'Subfolders',
  newFolder: 'New Folder',
  editFolder: 'Edit Folder',
  deleteFolder: 'Delete Folder',
  folderColor: 'Folder Color',
  moveToRoot: 'Move to Root',
  tagManagement: 'Tag Management',
  renameTag: 'Rename Tag',
  mergeTags: 'Merge Tags',
  deleteTag: 'Delete Tag',
  tagUsage: 'Tag Usage'
};
